

<template>
    <v-layout align-start>
        <v-flex>
            <v-data-table 
            :headers="headers"
            :items="materials"
            :search="search"
            sort-by=""
            class="elevation-1"
            >
            <template v-slot:top>
                    <v-toolbar flat color="white">
                    <v-toolbar-title>Paper Pilot</v-toolbar-title>
                    <v-divider
                        class="mx-4"
                        inset
                        vertical
                    ></v-divider>                    
                    <v-spacer></v-spacer>
                    <v-text-field class="text-xs-center" v-model="search" append-icon="search" label="Search" single-line hide-details></v-text-field>
                    <v-btn @click="listInvoices()" color="primary" 
                    dark class="mb-2"
                    :disabled="dialogLoading"
                    :loading="dialogLoading"
                    >Seach</v-btn>
                      <v-dialog
                                v-model="dialogLoading"
                                hide-overlay
                                persistent
                                width="300"
                                >
                                <v-card
                                    color="primary"
                                    dark
                                >
                                    <v-card-text>
                                    Loading, please be patient.
                                    <v-progress-linear
                                        indeterminate
                                        color="white"
                                        class="mb-0"
                                    ></v-progress-linear>
                                    </v-card-text>
                                </v-card>
                                </v-dialog>            

                            </v-card-actions>
                        </v-card>
                        </v-dialog>
                    <v-spacer></v-spacer> 

<vue-json-to-csv :json-data="materials" :csv-title="search">
</vue-json-to-csv>



            </v-toolbar>
        </template>
               
                <template v-slot:body="{ items }">
                    <tbody>
                        <tr v-for="item in items" :key="item.issueID">
                                           
                            <td class="text-xs-right">{{item.CSO}} </td>                            
                            <td class="text-xs-right">{{item.MATNR}} </td>
                            <td class="text-xs-right">{{item.MAKTX}} </td>
                            <td class="text-xs-right">{{item.BDMNG}} </td>                           
                           
                        </tr>
                    </tbody>
                </template>
                     
                
                <template v-slot:no-data>
                    <v-btn color="primary" @click="initialize">Reset</v-btn>
                </template>
    </v-data-table>
        </v-flex>
    </v-layout>
</template>

<script>    
    import axios from 'axios'; 
    import moment from 'moment'; 
    import VueJsonToCsv from 'vue-json-to-csv'
  
   
    export default{
        components: {    
                 "vue-json-to-csv": VueJsonToCsv          
        },       
        data (){
            return {
                  moment:moment,                
                  materials:[],                  
                  dialog: false,
                  dialogLoading: false,
                    headers: [
                        { text: 'CSO', value: 'CSO', sortable: false },                        
                        { text: 'Part Number', value: 'MATNR', sortable: true },
                        { text: 'Description', value: 'MAKTX', sortable: true },
                        { text: 'Qty', value: 'BDMNG', sortable: false }                      
                    ],
                    //moment: moment, // Set to whatever
                    privileges: false,
                    search: '',
                    desserts: [],
                    editedIndex: -1,
                  
                    id: '', 
                    invoiceNo: '', 
                    transportDestination: '', 
                    operatorName: '', 
                    boxNo: '', 
                    boxPlate: '', 
                    economicNo: '',
                    tractorPlate: '', 
                    sealNo: '', 
                    delivery_dt: '',                   
                    creator : '', 
                    create_dt: '', 
                  
                   
                    valida:0,
                    validaMensaje:[]   
                                
            }   
        },
        computed: {
            formTitle () {
                return this.editedIndex === -1 ? 'New Invoice' : 'Edit Invoice'
            },
                          
        },

        watch: {
            dialog (val) {
            val || this.close()
            } ,
             dialogLoading (val)  {
                if (!val) return
            }          
        },

        created () {
            this.initialize();           
            this.havePriviges();
            axios.defaults.baseURL = this.$SAPAPI;                        
        },

         methods: { 
              havePriviges() {
                this.$store.state.user.rol === "sap_dell" ? this.privileges =false : this.privileges =true
            } ,           
            listInvoices(){
               
                this.dialogLoading = true;
                let me=this;
                let header={"Authorization": "Bearer " + this.$store.state.token};
                let configuration = {headers : header };
                let url='';
                if (!me.search){
                    url ='api/PaperPilots/';
                }
                else{
                    url ='api/PaperPilots/' + me.search;                    
                }                
                axios.post('api/PaperPilots/',{
                    'cso': me.search
                    }).then(function(response){                  
                    me.materials = response.data;
                }).catch(function(error){
                    console.log(error);
                }).finally(() => this.dialogLoading  = false);  
            },
            
            initialize () {                            
            },
            
         
           

            close () {
                this.dialog = false;
                this.dialogLoading = false;
                this.clean();
            },            
                
          
        },
    }
</script>